import { Actor, Animation, SpriteSheet } from "excalibur";
import { Resources } from "../Resources";

export default class Bees extends Actor {
  constructor() {
    super();
    this.inspectBoxSprites = SpriteSheet.fromImageSource({
      image: Resources.InspectBoxSprites,
      grid: { rows: 4, columns: 12, spriteHeight: 80, spriteWidth: 80 },
    });
  }
  onInitialize() {
    this.oneChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(0, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(0, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(0, 2), duration: 100 },
      ],
    });
    this.twoChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(1, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(1, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(1, 2), duration: 100 },
      ],
    });
    this.threeChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(2, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(2, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(2, 2), duration: 100 },
      ],
    });
    this.fourChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(3, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(3, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(3, 2), duration: 100 },
      ],
    });
    this.fiveChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(4, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(4, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(4, 2), duration: 100 },
      ],
    });
    this.sixChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(5, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(5, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(5, 2), duration: 100 },
      ],
    });
    this.sevenChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(6, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(6, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(6, 2), duration: 100 },
      ],
    });
    this.eightChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(7, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(7, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(7, 2), duration: 100 },
      ],
    });
    this.nineChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(8, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(8, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(8, 2), duration: 100 },
      ],
    });
    this.tenChurn = new Animation({
      frames: [
        { graphic: this.inspectBoxSprites.getSprite(9, 0), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(9, 1), duration: 100 },
        { graphic: this.inspectBoxSprites.getSprite(9, 2), duration: 100 },
      ],
    });
    this.hundredFifty = new Animation({
      frames: [
        {
          graphic: this.inspectBoxSprites.getSprite(10, 0),
          duration: 100,
        },
        {
          graphic: this.inspectBoxSprites.getSprite(10, 1),
          duration: 100,
        },
        {
          graphic: this.inspectBoxSprites.getSprite(10, 2),
          duration: 100,
        },
      ],
    });
    this.twoHundred = new Animation({
      frames: [
        {
          graphic: this.inspectBoxSprites.getSprite(11, 0),
          duration: 100,
        },
        {
          graphic: this.inspectBoxSprites.getSprite(11, 1),
          duration: 100,
        },
        {
          graphic: this.inspectBoxSprites.getSprite(11, 2),
          duration: 100,
        },
      ],
    });
    this.graphics.add("oneChurn", this.oneChurn);
    this.graphics.add("twoChurn", this.twoChurn);
    this.graphics.add("threeChurn", this.threeChurn);
    this.graphics.add("fourChurn", this.fourChurn);
    this.graphics.add("fiveChurn", this.fiveChurn);
    this.graphics.add("sixChurn", this.sixChurn);
    this.graphics.add("sevenChurn", this.sevenChurn);
    this.graphics.add("eightChurn", this.eightChurn);
    this.graphics.add("nineChurn", this.nineChurn);
    this.graphics.add("tenChurn", this.tenChurn);
    this.graphics.add("hundredFifty", this.hundredFifty);
    this.graphics.add("twoHundred", this.twoHundred);
  }
}
